import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocked = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.55556 11.1V7.5C7.55556 6.30653 8.02381 5.16193 8.8573 4.31802C9.6908 3.47411 10.8213 3 12 3C13.1787 3 14.3092 3.47411 15.1427 4.31802C15.9762 5.16193 16.4444 6.30653 16.4444 7.5V11.1M5.77778 11.1H18.2222C19.2041 11.1 20 11.9059 20 12.9V19.2C20 20.1941 19.2041 21 18.2222 21H5.77778C4.79594 21 4 20.1941 4 19.2V12.9C4 11.9059 4.79594 11.1 5.77778 11.1Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgLocked);
export { ForwardRef as ReactComponent };
